<template>
  <div class="page modal-page d-flex flex-column">
    <div class="row header-page">
      <div class="col">
        <h3>
          Personalizza
        </h3>
        <div class="row banner-area">
          <div class="col">
            <div class="banner">
              <div class="custom-contribs-subtitle mb-1">
                Gestione Armonia
              </div>
              <div class="d-flex flex-row">
                <div class="custom-capital-info mb-3">
                  <span class="capital-value">
                    {{ getCustomizableCapital() }} &euro;</span
                  >
                  di {{ getFullCapital() }} &euro; versati
                </div>
                <div class="ml-auto">
                  <b-button
                    variant="link red-link text-right m-0 p-0"
                    @click="resetAreaValues()"
                    ><u>Ripristina valori</u></b-button
                  >
                </div>
              </div>
              <div class="mb-5">
                <custom-slider
                  v-if="showSlider"
                  v-model="contribsDivision"
                  :colors="contribsColors"
                ></custom-slider>
              </div>
              <div class="d-flex pt-4">
                <div
                  v-for="(area, index) in areaList"
                  v-bind:key="area.id"
                  :key="index"
                  class="area-customer-slider-legend mr-4"
                >
                  <div class="d-flex flex-row align-items-center">
                    <div
                      class="legend-dot"
                      v-bind:style="{ background: area.color }"
                    ></div>
                    <div class="legend-item">
                      {{ area.title }}
                    </div>
                  </div>
                  <div class="legend-desc">{{ area.value }} &euro;</div>
                </div>
              </div>
              <div
                class="d-flex mt-5 flex-column"
                v-if="contribsTrend.inc !== null || contribsTrend.dec !== null"
              >
                <div class="contribs-trend-box border-1 mt-3">
                  <div class="contrib-title mb-2">
                    <img
                      src="../../assets/images/icon-increase.svg"
                      class="mr-2"
                    />
                    Contributi in aumento
                  </div>
                  <div class="contrib-list mb-3">
                    <template
                      v-if="
                        contribsTrend.inc !== null &&
                          areaList.filter(a => a.id === contribsTrend.inc)
                            .length > 0
                      "
                    >
                      <img
                        v-for="(contrib, i) in areaList.filter(
                          a => a.id === contribsTrend.inc
                        )[0].contribs"
                        :key="i"
                        :src="contrib.icon"
                        class="contrib-icon mr-3"
                      />
                    </template>
                  </div>
                </div>
                <div class="contribs-trend-box border-0 mt-3">
                  <div class="contrib-title mb-2">
                    <img
                      src="../../assets/images/icon-decrease.svg"
                      class="mr-2"
                    />
                    Contributi in diminuzione
                  </div>
                  <div class="contrib-list mb-3">
                    <template
                      v-if="
                        contribsTrend.dec !== null &&
                          areaList.filter(a => a.id === contribsTrend.dec)
                            .length > 0
                      "
                    >
                      <img
                        v-for="(contrib, i) in areaList.filter(
                          a => a.id === contribsTrend.dec
                        )[0].contribs"
                        :key="i"
                        :src="contrib.icon"
                        class="contrib-icon mr-3"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex footer-page">
      <b-button variant="link" @click="cancelAction()">
        Annulla
      </b-button>
      <b-button variant="primary ml-auto" @click="processData()"
        >Conferma</b-button
      >
    </div>
  </div>
</template>

<script>
import router from "../../router";
import CustomSlider from "../../components/CustomSlider";
import { getAreaListData } from "../../data/area-list.data";

export default {
  name: "CustomContribsValue",
  components: { CustomSlider },
  data: () => {
    return {
      val: false,
      modal: false,
      showSlider: true,
      contribsDivision: [],
      contribsDivisionPrev: [],
      contribsColors: [],
      contribsTrend: {
        inc: null,
        dec: null
      },
      areaList: [],
      areaListPrev: []
    };
  },
  created() {
    this.areaList = JSON.parse(
      JSON.stringify(getAreaListData(this.$store.state.areaValue))
    );
    this.areaList.filter(a => {
      if (this.$store.state.areaValue.filter(v => v.id === a.id).length > 0) {
        a.selected = true;
        a.value = this.$store.state.areaValue.filter(
          v => v.id === a.id
        )[0].value;
      } else {
        a.selected = false;
        a.value = 0;
      }
      return true;
    });
    this.areaList = this.areaList.filter(
      a => this.$store.state.areaValue.filter(sa => sa.id === a.id).length > 0
    );
    this.areaListPrev = this.areaList.map(a => {
      return {
        id: a.id,
        value: a.value,
        contribs: a.contribs
      };
    });
    this.contribsColors = this.areaList.map(a => a.color);

    this.initContribsSliderValues();
  },
  watch: {
    contribsDivision(after) {
      this.contribsDivision = after;
      this.areaList.forEach((area, index) => {
        const perc =
          this.contribsDivision[index + 1] - this.contribsDivision[index];
        // console.log("perc " + perc);
        let newValue =
          ((perc / 100) * parseInt(this.$store.state.capitalValue)) / 2;
        newValue = newValue.toFixed(0);
        if (area.value !== newValue) {
          if (newValue > area.value) {
            this.contribsTrend.inc = area.id;
          }
          if (newValue < area.value) {
            this.contribsTrend.dec = area.id;
          }
          this.areaListPrev.filter(a => {
            if (a.id === area.id) {
              a.value = area.value;
            }
          });
          area.value = newValue;
        }
      });
    }
  },
  methods: {
    initContribsSliderValues() {
      this.contribsDivision = [];

      const newDivisions = [];

      for (let i = 0; i < this.areaList.length; i++) {
        const perc = Math.round(
          (this.areaList[i].value / (this.$store.state.capitalValue / 2)) * 100
        );
        // console.log("perc", perc);
        newDivisions.push(perc);
      }
      const newArray = [];
      for (let i = 0; i < newDivisions.length; i++) {
        if (i === 0) {
          newArray.push(newDivisions[i]);
        } else {
          newArray.push(newDivisions[i] + newArray[i - 1]);
        }
      }
      newArray[newArray.length - 1] =
        newArray[newArray.length - 1] + (100 - newArray[newArray.length - 1]);
      this.contribsDivision.push(0, ...newArray);
    },
    processData() {
      this.saveState();
      this.$emit("modalAction", "close");
    },
    cancelAction() {
      this.$emit("modalAction", "close");
    },
    saveState() {
      const stateAreaValue = this.$store.state.areaValue;

      stateAreaValue.forEach(area => {
        area.value = this.areaList.filter(a => a.id === area.id)[0].value;
      });
      this.$store.commit("setAreaValue", []);
      this.$store.commit("setAreaValue", stateAreaValue);
    },
    showModal() {
      this.modal = true;
    },
    getCustomizableCapital() {
      return this.$store.state.capitalValue / 2;
    },
    getFullCapital() {
      return this.$store.state.capitalValue;
    },
    resetAreaValues() {
      this.contribsDivision = [];
      this.areaList.forEach((area, index) => {
        this.contribsDivision.push(
          index * Math.round(100 / this.areaList.length)
        );
      });
      this.contribsDivision.push(100);
      this.showSlider = false;
      setTimeout(() => {
        this.showSlider = true;
      }, 1);
    },
    back() {
      router.go(-1);
    }
  }
};
</script>
